import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import IconCore from '@vds-core/icons';
import IconData from './data.json';
var propTypes = {
  /**
   * JSON File with paths for new Icons for 1.0.
   */
  data: PropTypes.object,

  /**
   * Boolean to change Icon stroke from default of 1px to 2px.
   */
  medium: PropTypes.bool
};
var defaultProps = {
  data: IconData,
  medium: false
};

var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(IconCore, _extends({}, props, {
    data: IconData,
    hasStroke: false,
    medium: false,
    focusState: false,
    focused: false
  }));
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
export default Icon;